export const esES = {
  JOURNEY_LIST: {
    CREATE_JOURNEY_BUTTON: 'Crear um nuevo camino',
  },
}

export default esES
